import type { BillingSchedule, BillingSchedulePhaseData, BillingScheduleInvoiceData } from '@features/billing-schedules/types/billing-schedule.types'
import type { BaseTimelineEvent } from '@shared/components/panels/components/domain-sections/Timeline/types'
import type { PaymentDetail } from '@shared/components/panels/types/panel-common.types'

// TODO: Replace with real billing schedule timeline data
export const BILLING_SCHEDULE_TIMELINE_EVENTS_DATA: BaseTimelineEvent[] = [
  {
    id: '1',
    title: 'Invoice #INV93u4239u4 sent to Customer name',
    timestamp: '2025-10-09T14:56:00Z'
  },
  {
    id: '2',
    title: 'Customer name signed off the contract',
    timestamp: '2025-10-09T14:56:00Z'
  },
  {
    id: '3',
    title: 'Billing schedule created',
    timestamp: '2025-09-30T14:56:00Z'
  }
]

const SHARED_PHASES: BillingSchedulePhaseData[] = [
  {
    id: '1',
    name: 'Initial Phase',
    period: '1 Jan - 30 Jun, 2024',
    items: [
      { id: '1-1', name: 'SaaS Pro Plan', type: 'Subscription', repeats: 'Monthly', billed: 'In arrears', amount: '$120.00' },
      { id: '1-2', name: 'Analytics Module', type: 'Add-on', repeats: 'Monthly', billed: 'In arrears', amount: '$45.00' }
    ]
  },
  {
    id: '2',
    name: 'Renewal Phase',
    period: '1 Jul - 31 Dec, 2024',
    items: [
      { id: '2-1', name: 'SaaS Pro Plan', type: 'Subscription', repeats: 'Monthly', billed: 'In arrears', amount: '$120.00' }
    ]
  }
]

const SHARED_INVOICES: BillingScheduleInvoiceData[] = [
  { id: '1', total: '$2500.00 USD', status: 'pending_approval', invoiceNumber: 'INV-DRAFT', billingPeriod: '1 Oct - 31 Oct, 2025', sent: '-', due: '-', finalized: '-' },
  { id: '2', total: '$20.00 USD', status: 'draft', invoiceNumber: 'INV-DRAFT', billingPeriod: '1 Oct - 31 Oct, 2025', sent: '-', due: '-', finalized: '-' },
  { id: '3', total: '$20.00 USD', status: 'open', invoiceNumber: 'INV00068', billingPeriod: '1 Oct - 31 Oct, 2025', sent: '10 Oct', due: '10 Oct', finalized: '10 Oct' },
  { id: '4', total: '$20.00 USD', status: 'paid', invoiceNumber: 'INV00068', billingPeriod: '1 Nov - 30 Nov, 2025', sent: '20 Oct', due: '20 Oct', finalized: '20 Oct' },
  { id: '5', total: '$20.00 USD', status: 'partially_paid', invoiceNumber: 'INV00068', billingPeriod: '1 Nov - 30 Nov, 2025', sent: '20 Oct', due: '20 Oct', finalized: '20 Oct' }
]

export const mockBillingSchedules: BillingSchedule[] = [
  {
    id: 'sched_001', customerId: 'cust_001', customerName: 'John Doe', customerEmail: 'john.doe@example.com',
    status: 'active',
    products: [
      { id: 'p1', name: 'SaaS Pro Plan', type: 'Subscription', repeats: 'Monthly', billed: 'In arrears', amount: '$120.00' },
      { id: 'p2', name: 'Analytics Module', type: 'Add-on', repeats: 'Monthly', billed: 'In arrears', amount: '$45.00' }
    ],
    startDate: '2024-01-01', endDate: '2024-12-31',
    paymentTerms: '30 Days', requiresApproval: true, poNumber: 'PO-2024-001', label: 'Annual SaaS Contract',
    invoiceMemo: 'Standard billing for SaaS Pro Plan subscription.',
    phases: SHARED_PHASES, invoices: SHARED_INVOICES,
    nextInvoiceAmount: '$165.00', nextInvoiceDate: '1 Nov',
    createdAt: '2023-12-15T10:00:00Z', updatedAt: '2024-06-01T14:30:00Z'
  },
  {
    id: 'sched_002', customerId: 'cust_002', customerName: 'Jane Smith', customerEmail: 'jane.smith@example.com',
    status: 'active',
    products: [
      { id: 'p3', name: 'Enterprise License', type: 'License', repeats: 'Yearly', billed: 'In advance', amount: '$5,000.00' },
      { id: 'p4', name: 'Support Package', type: 'Service', repeats: 'Monthly', billed: 'In arrears', amount: '$200.00' }
    ],
    startDate: '2024-01-05', endDate: '2024-12-31',
    paymentTerms: '30 Days', requiresApproval: false,
    invoiceMemo: 'Enterprise license with support package.',
    phases: [{ id: '1', name: 'Full Year', period: '5 Jan - 31 Dec, 2024', items: [
      { id: '1-1', name: 'Enterprise License', type: 'License', repeats: 'Yearly', billed: 'In advance', amount: '$5,000.00' },
      { id: '1-2', name: 'Support Package', type: 'Service', repeats: 'Monthly', billed: 'In arrears', amount: '$200.00' }
    ]}],
    invoices: SHARED_INVOICES.slice(2),
    nextInvoiceAmount: '$200.00', nextInvoiceDate: '5 Nov',
    createdAt: '2023-12-20T09:00:00Z', updatedAt: '2024-05-15T11:00:00Z'
  },
  {
    id: 'sched_003', customerId: 'cust_003', customerName: 'Acme Corporation', customerEmail: 'billing@acme.com',
    status: 'draft',
    products: [
      { id: 'p5', name: 'Enterprise Contract', type: 'Contract', repeats: 'Monthly', billed: 'In arrears', amount: '$2,500.00' },
      { id: 'p6', name: 'Premium Support', type: 'Service', repeats: 'Monthly', billed: 'In arrears', amount: '$500.00' }
    ],
    startDate: '2024-02-01', endDate: '2025-01-31',
    paymentTerms: '60 Days', requiresApproval: true, poNumber: 'PO-ACME-2024', label: 'Enterprise Contract',
    invoiceMemo: 'Enterprise contract with premium support. NET 60 payment terms.',
    phases: [{ id: '1', name: 'Contract Period', period: '1 Feb 2024 - 31 Jan 2025', items: [
      { id: '1-1', name: 'Enterprise Contract', type: 'Contract', repeats: 'Monthly', billed: 'In arrears', amount: '$2,500.00' },
      { id: '1-2', name: 'Premium Support', type: 'Service', repeats: 'Monthly', billed: 'In arrears', amount: '$500.00' }
    ]}],
    invoices: [],
    createdAt: '2024-01-10T08:00:00Z', updatedAt: '2024-01-10T08:00:00Z'
  },
  {
    id: 'sched_004', customerId: 'cust_004', customerName: 'TechStart Inc', customerEmail: 'finance@techstart.io',
    status: 'active',
    products: [
      { id: 'p7', name: 'Cloud Services', type: 'Infrastructure', repeats: 'Monthly', billed: 'In arrears', amount: '$350.00' },
      { id: 'p8', name: 'Storage Plan', type: 'Add-on', repeats: 'Monthly', billed: 'In arrears', amount: '$75.00' }
    ],
    startDate: '2023-11-15', endDate: '2024-11-15',
    paymentTerms: '14 Days', requiresApproval: false,
    phases: [{ id: '1', name: 'Annual Plan', period: '15 Nov 2023 - 15 Nov 2024', items: [
      { id: '1-1', name: 'Cloud Services', type: 'Infrastructure', repeats: 'Monthly', billed: 'In arrears', amount: '$350.00' },
      { id: '1-2', name: 'Storage Plan', type: 'Add-on', repeats: 'Monthly', billed: 'In arrears', amount: '$75.00' }
    ]}],
    invoices: SHARED_INVOICES.slice(2, 5),
    nextInvoiceAmount: '$425.00', nextInvoiceDate: '15 Nov',
    createdAt: '2023-11-01T10:00:00Z', updatedAt: '2024-04-20T16:00:00Z'
  },
  {
    id: 'sched_005', customerId: 'cust_005', customerName: 'Global Retail Ltd', customerEmail: 'payments@globalretail.com',
    status: 'completed',
    products: [
      { id: 'p9', name: 'E-commerce Platform', type: 'Platform', repeats: 'Monthly', billed: 'In arrears', amount: '$800.00' },
      { id: 'p10', name: 'Payment Gateway', type: 'Service', repeats: 'Monthly', billed: 'In arrears', amount: '$150.00' }
    ],
    startDate: '2023-09-01', endDate: '2023-12-31',
    paymentTerms: '30 Days', requiresApproval: false,
    phases: [{ id: '1', name: 'Q4 2023', period: '1 Sep - 31 Dec, 2023', items: [
      { id: '1-1', name: 'E-commerce Platform', type: 'Platform', repeats: 'Monthly', billed: 'In arrears', amount: '$800.00' },
      { id: '1-2', name: 'Payment Gateway', type: 'Service', repeats: 'Monthly', billed: 'In arrears', amount: '$150.00' }
    ]}],
    invoices: SHARED_INVOICES.slice(3, 5),
    createdAt: '2023-08-15T12:00:00Z', updatedAt: '2024-01-02T09:00:00Z'
  },
  {
    id: 'sched_006', customerId: 'cust_006', customerName: 'Marketing Plus Agency', customerEmail: 'accounts@marketingplus.com',
    status: 'active',
    products: [
      { id: 'p11', name: 'Marketing Tools', type: 'SaaS', repeats: 'Monthly', billed: 'In advance', amount: '$250.00' },
      { id: 'p12', name: 'CRM Integration', type: 'Add-on', repeats: 'Monthly', billed: 'In advance', amount: '$100.00' }
    ],
    startDate: '2023-10-20', endDate: '2024-10-20',
    paymentTerms: '7 Days', requiresApproval: false,
    phases: [{ id: '1', name: 'Annual Plan', period: '20 Oct 2023 - 20 Oct 2024', items: [
      { id: '1-1', name: 'Marketing Tools', type: 'SaaS', repeats: 'Monthly', billed: 'In advance', amount: '$250.00' },
      { id: '1-2', name: 'CRM Integration', type: 'Add-on', repeats: 'Monthly', billed: 'In advance', amount: '$100.00' }
    ]}],
    invoices: SHARED_INVOICES.slice(2, 4),
    nextInvoiceAmount: '$350.00', nextInvoiceDate: '20 Nov',
    createdAt: '2023-10-05T14:00:00Z', updatedAt: '2024-03-10T10:00:00Z'
  },
  {
    id: 'sched_007', customerId: 'cust_007', customerName: 'Design Studio Pro', customerEmail: 'billing@designstudio.pro',
    status: 'completed',
    products: [
      { id: 'p13', name: 'Creative Suite', type: 'License', repeats: 'Monthly', billed: 'In advance', amount: '$300.00' },
      { id: 'p14', name: 'Asset Library', type: 'Add-on', repeats: 'One time', billed: 'In advance', amount: '$500.00' }
    ],
    startDate: '2023-07-15', endDate: '2023-12-15',
    paymentTerms: '30 Days', requiresApproval: false,
    phases: [{ id: '1', name: 'H2 2023', period: '15 Jul - 15 Dec, 2023', items: [
      { id: '1-1', name: 'Creative Suite', type: 'License', repeats: 'Monthly', billed: 'In advance', amount: '$300.00' },
      { id: '1-2', name: 'Asset Library', type: 'Add-on', repeats: 'One time', billed: 'In advance', amount: '$500.00' }
    ]}],
    invoices: SHARED_INVOICES.slice(3),
    createdAt: '2023-07-01T09:00:00Z', updatedAt: '2023-12-16T08:00:00Z'
  },
  {
    id: 'sched_008', customerId: 'cust_008', customerName: 'Data Analytics Co', customerEmail: 'finance@dataanalytics.co',
    status: 'active',
    products: [
      { id: 'p15', name: 'BI Platform', type: 'Platform', repeats: 'Monthly', billed: 'In arrears', amount: '$600.00' },
      { id: 'p16', name: 'Data Warehouse', type: 'Infrastructure', repeats: 'Monthly', billed: 'In arrears', amount: '$400.00' }
    ],
    startDate: '2023-12-01', endDate: '2024-11-30',
    paymentTerms: '30 Days', requiresApproval: true, poNumber: 'PO-DA-2024',
    invoiceMemo: 'BI Platform and Data Warehouse annual contract.',
    phases: SHARED_PHASES, invoices: SHARED_INVOICES,
    nextInvoiceAmount: '$1,000.00', nextInvoiceDate: '1 Dec',
    createdAt: '2023-11-15T11:00:00Z', updatedAt: '2024-06-01T15:00:00Z'
  },
  {
    id: 'sched_009', customerId: 'cust_009', customerName: 'Healthcare Systems Inc', customerEmail: 'accounts@healthcaresys.com',
    status: 'draft',
    products: [
      { id: 'p17', name: 'Healthcare Management', type: 'Platform', repeats: 'Monthly', billed: 'In arrears', amount: '$1,200.00' },
      { id: 'p18', name: 'Compliance Module', type: 'Add-on', repeats: 'Monthly', billed: 'In arrears', amount: '$300.00' }
    ],
    startDate: '2024-06-01', endDate: '2025-05-31',
    paymentTerms: '60 Days', requiresApproval: true, poNumber: 'PO-HC-2024-Q2', label: 'Healthcare Annual Contract',
    invoiceMemo: 'Healthcare management platform with compliance module.',
    phases: [{ id: '1', name: 'Year 1', period: '1 Jun 2024 - 31 May 2025', items: [
      { id: '1-1', name: 'Healthcare Management', type: 'Platform', repeats: 'Monthly', billed: 'In arrears', amount: '$1,200.00' },
      { id: '1-2', name: 'Compliance Module', type: 'Add-on', repeats: 'Monthly', billed: 'In arrears', amount: '$300.00' }
    ]}],
    invoices: [],
    createdAt: '2024-05-01T10:00:00Z', updatedAt: '2024-05-15T14:00:00Z'
  },
  {
    id: 'sched_010', customerId: 'cust_010', customerName: 'Education First Ltd', customerEmail: 'billing@edufirst.edu',
    status: 'draft',
    products: [
      { id: 'p19', name: 'LMS Platform', type: 'Platform', repeats: 'Monthly', billed: 'In advance', amount: '$450.00' },
      { id: 'p20', name: 'Student Portal', type: 'Add-on', repeats: 'Monthly', billed: 'In advance', amount: '$150.00' }
    ],
    startDate: '2024-09-01', endDate: '2025-06-30',
    paymentTerms: '30 Days', requiresApproval: false, label: 'Academic Year 2024-25',
    phases: [{ id: '1', name: 'Academic Year', period: '1 Sep 2024 - 30 Jun 2025', items: [
      { id: '1-1', name: 'LMS Platform', type: 'Platform', repeats: 'Monthly', billed: 'In advance', amount: '$450.00' },
      { id: '1-2', name: 'Student Portal', type: 'Add-on', repeats: 'Monthly', billed: 'In advance', amount: '$150.00' }
    ]}],
    invoices: [],
    createdAt: '2024-08-01T08:00:00Z', updatedAt: '2024-08-20T12:00:00Z'
  }
]

// Re-export invoice type for backwards compatibility
export type { BillingScheduleInvoiceData as BillingScheduleInvoice } from '@features/billing-schedules/types/billing-schedule.types'

// Generate general section data from a billing schedule
export const generateBillingScheduleGeneralData = (schedule?: BillingSchedule): PaymentDetail[] => {
  if (!schedule) {
    return [
      { label: 'Customer', value: '-', isCopyable: false },
      { label: 'Period', value: '-', isCopyable: false },
      { label: 'Payment Terms', value: '-', isCopyable: false },
      { label: 'Requires Approval', value: '-', isCopyable: false },
      { label: 'PO Number', value: '-', isCopyable: false },
      { label: 'Label', value: '-', isCopyable: false },
      { label: 'Invoice memo', value: '-', isCopyable: false }
    ]
  }

  return [
    { label: 'Customer', value: schedule.customerName, isCopyable: false },
    { label: 'Period', value: `${schedule.startDate} — ${schedule.endDate}`, isCopyable: false },
    { label: 'Payment Terms', value: schedule.paymentTerms, isCopyable: false },
    { label: 'Requires Approval', value: schedule.requiresApproval ? 'Yes' : 'No', isCopyable: false },
    { label: 'PO Number', value: schedule.poNumber || '-', isCopyable: false },
    { label: 'Label', value: schedule.label || '-', isCopyable: false },
    { label: 'Invoice memo', value: schedule.invoiceMemo || '-', isCopyable: false }
  ]
}

// Generate phases data from a billing schedule
export const generateBillingSchedulePhasesData = (schedule?: BillingSchedule): BillingSchedulePhaseData[] => {
  if (!schedule) return []
  return schedule.phases
}
